import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, touchTarget} from "../../../../../theme/modern/touchTargets"

/** Matches <ModernAppBar/>'s `iconbtn`, since this sits in that bar. */
export default makeStyles((theme: ModernTheme) => ({
    btn: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        height: 30,
        padding: "0 10px",
        borderRadius: 7,
        border: `1px solid ${theme.modern.line}`,
        background: theme.modern.panel,
        color: theme.modern.ink2,
        fontFamily: theme.modern.sans,
        fontWeight: 500,
        fontSize: 12,
        whiteSpace: "nowrap",
        cursor: "pointer",
        flex: "none",

        "&:hover": {
            borderColor: theme.modern.ink3,
            color: theme.modern.ink,
        },

        "& svg": {width: 14, height: 14, flex: "none"},

        [COARSE]: touchTarget({height: "auto", padding: "0 12px"}),
    },
    /** The label goes before the record name does — the arrow still reads. */
    label: {
        "@media (max-width:900px)": {display: "none"},
    },
    note: {
        display: "block",
        marginTop: 6,
        color: theme.modern.ink2,
    },
}))
